import { trpcVanilla } from "@client/trpc";
import {
  createSyncFeature,
  type StorageLike,
  type SyncFeature,
} from "@client/sync";
import { type BookmarkRow } from "@lib/videoStateTypes";

export interface BookmarkPayload {
  videoId: string;
  bookmarked: boolean;
  clientUpdatedAt: string;
}

export interface BookmarkFlushResult {
  applied: boolean;
  current: BookmarkRow | null;
}

export function createBookmarkSync(args: {
  onSuccess: (result: BookmarkFlushResult, payload: BookmarkPayload) => void;
  storage?: StorageLike;
  storageKey?: string;
  shouldCommit?: () => boolean;
}): SyncFeature<BookmarkPayload> {
  return createSyncFeature<BookmarkPayload, BookmarkFlushResult>({
    storageKey: args.storageKey ?? "mobileVideoSync.bookmark.v1",
    coalesce: (existing, incoming) =>
      existing.videoId === incoming.videoId ? incoming : null,
    send: (payload) =>
      trpcVanilla.setVideoBookmark.mutate({
        videoId: payload.videoId,
        bookmarked: payload.bookmarked,
        clientUpdatedAt: payload.clientUpdatedAt,
      }),
    onSuccess: args.onSuccess,
    storage: args.storage,
    shouldCommit: args.shouldCommit,
  });
}
